import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'found';
import classNames from 'classnames';
import style from './style.css';

const BUTTON_STYLES = ['default', 'primary', 'info'];
const BUTTON_SIZES = ['normal', 'large', 'small'];


export default class Button extends React.Component {

  static propTypes = {
    onClick: PropTypes.func,
    btnStyle: PropTypes.oneOf(BUTTON_STYLES).isRequired,
    btnSize: PropTypes.oneOf(BUTTON_SIZES).isRequired,
    className: PropTypes.string,
    href: PropTypes.string,
    to: PropTypes.string,
    disabled: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    pullRight: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    btnStyle: 'default',
    btnSize: 'normal',
    disabled: false,
    type: 'button',
    pullRight: false,
    children: ''
  };

  render() {
    const {
      btnStyle, btnSize, href, to,
      className, type, pullRight, ...props} = this.props;
    props.className = classNames(
      style.btn, style[`${btnStyle}Btn`], style[`${btnSize}SzBtn`], className);
    if (pullRight) {
      props.className = classNames(style.pullRight, props.className);
    }
    if (href) {
      return <a href={href} {...props} />;
    } else if (to) {
      return <Link to={to} {...props} />;
    } else {
      return <button type={type} {...props} />;
    }
  }
    

}



// WEBPACK FOOTER //
// ./src/views/fragments/button/index.js